import { Grid, IconButton, makeStyles, TextField, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { GetResourceQuery, UpdateResourceInput } from '../../../../API';
import ResourceService from '../../ResourceService';
import ResourcePageProps from './ResourcePageProps';

const useStyles = makeStyles((theme) => ({
    reportIssue: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    }
}));

export default function ResourcePage(props: PropsWithChildren<ResourcePageProps>) {

    const classes = useStyles();

    const [resource, setResource] = useState<GetResourceQuery['getResource']>();

    const [titleEditMode, setTitleEditMode] = useState<boolean>(false);
    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (resource) {
            setResource({ ...resource, title: e.target.value });
        }
    }

    const [descriptionEditMode, setDescriptionEditMode] = useState<boolean>(false);
    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (resource) {
            setResource({ ...resource, description: e.target.value });
        }
    }

    const [groups, setGroups] = useState<string[]>();
    useEffect(() => {
        if (!groups) {
            setGroups(props.user?.getSignInUserSession()?.getAccessToken().payload['cognito:groups']);
        }
    });

    useEffect(() => {
        if (props.id) {
            ResourceService.getResource(props.id).then(resourceQuery => {
                if (resourceQuery.data) {
                    setResource(resourceQuery.data.getResource);
                    props.onResourceLoaded(resourceQuery.data.getResource);
                } else {
                    // TODO: implementƒ
                    // setError()
                }
            });
        }
    }, []);

    return (
        <div>
            <div>
                <Grid container>
                    <Grid item>
                        {!titleEditMode ?
                            <Typography variant="h6" component="h2" gutterBottom>
                                <strong>{resource?.title || "Untitled Resource"}</strong>
                            </Typography>
                            :
                            <TextField value={resource?.title} onChange={handleTitleChange} />}
                    </Grid>
                    {groups && groups.indexOf('admin') >= 0 && <Grid item>
                        {!titleEditMode ?
                            <IconButton size="small" onClick={() => setTitleEditMode(true)}>
                                <EditIcon color="primary" />
                            </IconButton>
                            :
                            <IconButton size="small" onClick={() => {
                                setTitleEditMode(false);
                                if (resource) {
                                    props.onResourceUpdate(resource);
                                }
                            }}>
                                <SaveIcon color="primary" />
                            </IconButton>
                        }
                    </Grid>}
                </Grid>
                <div>
                    {props.children}
                </div>
                <Grid container>
                    <Grid item xs={6}>
                        Last Updated: {resource?.updatedAt && (new Date(resource?.updatedAt)).toLocaleDateString()} {resource?.updatedAt && (new Date(resource?.updatedAt)).toLocaleTimeString()}
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                </Grid >
                <Grid container>
                    <Grid item>
                        {!descriptionEditMode ?
                            <Typography variant="subtitle2" component="h2">
                                {resource?.description}
                            </Typography>
                            :
                            <TextField value={resource?.description} onChange={handleDescriptionChange} />}
                    </Grid>
                    {groups && groups.indexOf('admin') >= 0 && <Grid item>
                        {!descriptionEditMode ?
                            <IconButton size="small" onClick={() => setDescriptionEditMode(true)}>
                                <EditIcon color="primary" />
                            </IconButton>
                            :
                            <IconButton size="small" onClick={() => {
                                setDescriptionEditMode(false);
                                if (resource) {
                                    props.onResourceUpdate(resource);
                                }
                            }}>
                                <SaveIcon color="primary" />
                            </IconButton>
                        }
                    </Grid>}
                </Grid>
            </div>
        </div >
    );
}